import React, { useState } from "react";
import Logo from "../imgs/logo.png";
import Facebook from "../facebook.svg";
import Youtube from "../youtube.svg";
import TikTok from "../tiktok.svg";
import Instagram from "../instagram.svg";

const NavbarMobile = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const socialLinks = [
    {
      href: "https://www.instagram.com/milarte.mi/",
      src: Instagram,
      alt: "Instagram",
    },
    {
      href: "https://www.tiktok.com/@milarteit?_t=ZN-8shsnggNJah&_r=1",
      src: TikTok,
      alt: "TikTok",
    },
    {
      href: "https://www.facebook.com/profile.php?id=61553129543902",
      src: Facebook,
      alt: "Facebook",
    },

    {
      href: "https://www.youtube.com/@MilArteAssociazioneCulturale",
      src: Youtube,
      alt: "YouTube",
    },
  ];
  const menuLinks = [
    { href: "#home", label: "Home" },
    { href: "#chi-siamo", label: "Chi Siamo" },
    { href: "#nuova-orchestra", label: "Nuova Orchestra" },
    { href: "#Milarte-Fa-Scuola", label: "Milarte Fa Scuola" },
    { href: "#suona-con-noi", label: "Suona con Noi" },
    { href: "#concerti", label: "Concerti" },
    { href: "#NewGallery", label: "Galleria" },
    { href: "#contatti", label: "Contatti" },
    { href: "#partners", label: "Partners" },
    { href: "#privacy", label: "Privacy" },
    { href: "#5x1000", label: "5x1000" },
  ];

  return (
    <>
      {/* Header */}
      <header className="top-0 left-0 right-0 bg-gradient-to-r from-white to-amber-50 shadow-md z-50 flex justify-between items-center px-5 py-3">
        {/* Logo */}
        <a href="#home" className={"flex items-center "}>
          <img src={Logo} alt="Logo" className="h-10 w-auto" />
        </a>

        {/* <button
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          className=" relative w-8 h-8 focus:outline-none z-50"
        >
       
          <span
            className={`block absolute left-0 w-8 h-0.5  rounded transition-transform duration-300 ease-in-out ${
              menuOpen ? "rotate-45 top-3.5 bg-white" : "top-2 bg-yellow-500"
            }`}
          ></span>
         
          <span
            className={`block absolute left-0 w-8 h-0.5 bg-yellow-500 rounded transition-opacity duration-300 ease-in-out ${
              menuOpen ? "opacity-0" : "top-4"
            }`}
          ></span>
         
          <span
            className={`block absolute left-0 w-8 h-0.5  rounded transition-transform duration-300 ease-in-out ${
              menuOpen ? "-rotate-45 top-3.5 bg-white" : "top-6 bg-yellow-500"
            }`}
          ></span>
        </button> */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          className={`${
            menuOpen
              ? "fixed top-4 right-5 z-[60]" // fissa la X in alto a destra
              : "relative z-50"
          } w-8 h-8 focus:outline-none`}
        >
          {/* Linea superiore */}
          <span
            className={`block absolute left-0 w-8 h-0.5 rounded transition-transform duration-300 ease-in-out ${
              menuOpen ? "rotate-45 top-3.5 bg-white" : "top-2 bg-yellow-500"
            }`}
          ></span>

          {/* Linea centrale */}
          <span
            className={`block absolute left-0 w-8 h-0.5 bg-yellow-500 rounded transition-opacity duration-300 ease-in-out ${
              menuOpen ? "opacity-0" : "top-4"
            }`}
          ></span>

          {/* Linea inferiore */}
          <span
            className={`block absolute left-0 w-8 h-0.5 rounded transition-transform duration-300 ease-in-out ${
              menuOpen ? "-rotate-45 top-3.5 bg-white" : "top-6 bg-yellow-500"
            }`}
          ></span>
        </button>
      </header>

      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-40 transition-opacity duration-300 z-40 ${
          menuOpen ? " pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* Side Menu */}
      {/* <nav
        className={`bg-opacity-85 fixed top-0 left-0 h-full w-64 bg-yellow-400 shadow-lg transform transition-transform duration-300 z-50 flex flex-col px-6 pt-24 pb-6 ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <ul className="flex flex-col space-y-6 text-white font-semibold text-lg">
          {menuLinks.map(({ href, label }, idx) => (
            <li key={idx}>
              <a
                href={href}
                onClick={() => setMenuOpen(false)}
                className="block hover:text-yellow-200 transition"
              >
                {label}
              </a>
            </li>
          ))}
        </ul>

        <div className="mt-auto flex  space-x-8">
          {socialLinks.map(({ href, src, alt }, idx) => (
            <a
              key={idx}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition"
              aria-label={alt}
            >
              <img src={src} alt={alt} className="w-6 h-6" />
            </a>
          ))}
        </div>
      </nav> */}
      <nav
        className={`bg-opacity-85 fixed top-0 left-0 h-full w-72 bg-amber-400  shadow-xl transform transition-transform duration-300 z-50 flex flex-col px-6 pt-3 pb-8 ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Logo sopra (opzionale) */}
        <div className="flex justify-center">
          <div className=" backdrop-blur-sm rounded-xl p-2 shadow-md">
            <img src={Logo} alt="Logo" className="h-12 w-auto" />
          </div>
        </div>

        {/* Menu links */}
        <ul className="flex flex-col mt-4 space-y-4 text-white font-semibold text-lg">
          {menuLinks.map(({ href, label }, idx) => (
            <li
              key={idx}
              className={`border-b border-white/20 pb-2 ${
                idx === 0 ? "text-white font-bold tracking-wide" : ""
              }`}
            >
              <a
                href={href}
                onClick={() => setMenuOpen(false)}
                className="block hover:text-amber-100 hover:translate-x-2 transform transition-all duration-200"
              >
                {label}
              </a>
            </li>
          ))}
        </ul>

        {/* Linea di separazione */}
        <div className=" border-t border-white/30"></div>

        {/* Social links */}
        <div className="flex mt-5  space-x-8">
          <div className="mt-auto flex  space-x-8">
            {socialLinks.map(({ href, src, alt }, idx) => (
              <a
                key={idx}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition"
                aria-label={alt}
              >
                <img src={src} alt={alt} className="w-6 h-6" />
              </a>
            ))}
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavbarMobile;
